import React from "react";
import { Button, Card, Empty, List, Segmented, Space, Typography } from "antd";

const { Text } = Typography;

const NotificationMobile = ({ viewModel }) => {
  const {
    loading,
    submitting,
    mobileFilter,
    setMobileFilter,
    isInboxOnly,
    unreadCount,
    mobileItems,
    onReadAll,
    onItemClick,
    goSettings,
    formatTime,
  } = viewModel;

  return (
    <Space direction="vertical" size={10} style={{ width: "100%" }}>
      <Card
        styles={{ body: { padding: 12 } }}
        style={{ position: "sticky", top: 0, zIndex: 9 }}
      >
        <Space direction="vertical" size={10} style={{ width: "100%" }}>
          <Space align="center" style={{ width: "100%", justifyContent: "space-between" }}>
            <Text strong style={{ fontSize: 16 }}>Thông báo</Text>
            <Button
              type="link"
              onClick={onReadAll}
              loading={submitting}
              disabled={unreadCount === 0}
              style={{ paddingInline: 4 }}
            >
              Đánh dấu đã đọc hết
            </Button>
          </Space>

          <Segmented
            block
            value={mobileFilter}
            onChange={(value) => setMobileFilter(value)}
            options={[
              { label: "Tất cả", value: "all" },
              { label: "Chưa đọc", value: "unread" },
            ]}
          />

          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            {!isInboxOnly ? <Button onClick={goSettings}>Cấu hình</Button> : null}
          </Space>
        </Space>
      </Card>

      <List
        loading={loading}
        dataSource={mobileItems}
        locale={{
          emptyText: <Empty description="Chưa có thông báo" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
        }}
        renderItem={(item) => (
          <List.Item style={{ padding: 0, border: 0, marginBottom: 10 }}>
            <Card
              hoverable
              onClick={() => onItemClick(item)}
              styles={{ body: { padding: 12 } }}
              style={{
                width: "100%",
                borderColor: item?.read_on ? "#f0f0f0" : "#91caff",
                background: item?.read_on ? "#fff" : "#f6ffed",
              }}
            >
              <Space direction="vertical" size={6} style={{ width: "100%" }}>
                <Space align="start" style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text strong style={{ paddingRight: 8 }}>{item.title}</Text>
                </Space>

                <Text>{item.message}</Text>

                <Space align="center" style={{ width: "100%", justifyContent: "space-between" }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    {formatTime(item.create_on)}
                  </Text>
                </Space>
              </Space>
            </Card>
          </List.Item>
        )}
      />
    </Space>
  );
};

export default React.memo(NotificationMobile);
